module.exports = __webpack_public_path__ + "img/2-dark.aa49d848.png";